var React = require('react');

function CallDont (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"currentColor","d":"M9.932 16.654l-3.348 3.348L5 18.415l3.263-3.263C5.7 12.457 5.117 9.709 5.034 9.118 4.926 8.447 4.95 6.73 7.08 5.234c.258-.193.8-.31.96-.176.063.054 2.266 3.084 2.32 3.184.053.1.106.201.102.308.015.15-.067.356-.25.587-.18.231-.376.479-.605.67a6.242 6.242 0 0 0-.593.653c-.182.232-.267.407-.255.527.037.27.278 1.066 1.467 2.203L16.415 7l1.586 1.586-6.015 6.015c1.873 1.338 2.748 1.708 2.845 1.74.105.034.179.042.237.036.115-.012.293-.137.445-.365.182-.232.753-1.262.95-1.48.182-.23.36-.356.504-.37a.817.817 0 0 1 .31.043c.135.031 3.407 1.6 3.47 1.653.19.162.128.715.025 1.013-.646 2.206-2.603 2.775-3.251 2.858-.199.02-3.04.479-7.589-3.075z"}));
}

CallDont.defaultProps = {"width":"25","height":"25","viewBox":"0 0 25 25"};

module.exports = CallDont;

CallDont.default = CallDont;
